import React from 'react';

const CnoPhotoContext = React.createContext({
    cnoPhoto: null,
    setCnoPhoto: () => {}
});

export default CnoPhotoContext;